import React, { SVGAttributes } from "react";

interface Props extends SVGAttributes<SVGElement> {}

const IconHighlighter: React.FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512.4 512.4"
      {...props}
    >
      <g fill="currentColor">
        <path d="M416 457H272a15 15 0 0 0 0 30h144a15 15 0 0 0 0-30zM67 400 4 461c-9 10-2 26 11 26h97c4 0 8-2 11-4l13-14zM107 280a72 72 0 0 0-18 67c3 10 2 21-3 30l73 73c9-5 20-6 30-3 24 6 49-1 67-18zM498 90l-44-47a56 56 0 0 0-78-4L129 259l148 149 221-242c19-22 19-54 0-76z" />
      </g>
    </svg>
  );
};

export default IconHighlighter;
